﻿(function () {
  var isRunning = false;
  var pendingSyncPromise = null;
  var syncFailed = false;
  // Messaggio informativo da (ri)mostrare finche resta pertinente: applyCheckoutGuard lo ridisegna ad
  // ogni sync, quindi sopravvive alla sostituzione dell'innerHTML del mini-cart che segue ogni modifica.
  var pendingNoticeText = null;
  // Un solo blocco al checkout per pagina: se dopo il tentativo di riallineamento la fee resta
  // disallineata non si perde la vendita per una fee. Deliberatamente non si riarma dopo una sync
  // riuscita: al secondo clic il JSON in pagina puo essere ancora quello pre-modifica, e un secondo
  // sync su dati stale aggiungerebbe una riga fee duplicata.
  var checkoutRetryDone = false;

  var languages = window.languages || {};
  var missingWeightAlertText = languages.packagingMissingWeight
    || 'Impossibile procedere al checkout: uno o piu prodotti con confezionamento premium non hanno il peso logistico configurato. Contatta l assistenza.';
  var feeAddedNoticeText = languages.packagingFeeAdded
    || 'Abbiamo aggiornato il carrello con il servizio di confezionamento previsto per i tuoi prodotti. Controlla il totale e procedi di nuovo al checkout.';
  var feeFailedNoticeText = languages.packagingFeeFailed
    || 'Non e stato possibile applicare il servizio di confezionamento. Ricarica la pagina del carrello e riprova.';

  function hasBlockingWeightError(feeData) {
    var lines = (feeData && feeData.lines) || [];
    return lines.some(function (line) {
      return !!(line && line.missingPkgWeightBlocking);
    });
  }

  function setCheckoutBlocked(isBlocked) {
    var checkoutButtons = document.querySelectorAll('button[name="checkout"], [data-action="checkout"]');
    checkoutButtons.forEach(function (button) {
      if (isBlocked) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function renderPackagingAlert(text) {
    var containers = document.querySelectorAll('.cart-recap__scroller, .mini-cart__content');
    containers.forEach(function (container) {
      var existing = container.querySelector('[data-pkg-weight-alert]');
      if (!text) {
        if (existing) { existing.remove(); }
        return;
      }
      if (!existing) {
        existing = document.createElement('p');
        existing.className = 'note';
        existing.setAttribute('data-pkg-weight-alert', 'true');
        existing.style.color = '#b42318';
        existing.style.fontWeight = '600';
        container.insertBefore(existing, container.firstChild);
      }
      existing.textContent = text;
    });
  }

  function applyCheckoutGuard(feeData) {
    var isBlocked = hasBlockingWeightError(feeData);
    setCheckoutBlocked(isBlocked);
    // Il peso mancante ha la precedenza: e l'unica condizione che blocca davvero il checkout.
    renderPackagingAlert(isBlocked ? missingWeightAlertText : pendingNoticeText);
    return isBlocked;
  }

  function parseFeeData() {
    var nodes = document.querySelectorAll('[data-packaging-fee-data]');
    if (!nodes || !nodes.length) { return null; }
    // Multiple JSON blocks can exist (layout + cart + mini-cart); prefer the most recent rendered one.
    for (var i = nodes.length - 1; i >= 0; i -= 1) {
      var node = nodes[i];
      if (!node || !node.textContent) { continue; }
      try {
        var parsed = JSON.parse(node.textContent);
        if (parsed && parsed.services && Array.isArray(parsed.lines)) { return parsed; }
      } catch (e) {}
    }
    return null;
  }

  function chooseBracket(brackets, totalWeight) {
    if (!Array.isArray(brackets) || !brackets.length || totalWeight <= 0) { return null; }
    var sorted = brackets
      .filter(function (entry) {
        return entry && entry.variantId && entry.maxGrams && entry.available !== false;
      })
      .sort(function (a, b) { return a.maxGrams - b.maxGrams; });

    if (!sorted.length) {
      // Peso da fatturare ma nessuna fascia utilizzabile: tipicamente il prodotto-fee traccia
      // l'inventario ed e esaurito. Nessuna fee verra applicata a nessuno finche resta cosi.
      if (window.console && console.warn) {
        console.warn('[packaging-fee] nessuna fascia disponibile per ' + totalWeight + 'g: verificare disponibilita e pubblicazione delle varianti del prodotto-fee');
      }
      return null;
    }

    var match = sorted.find(function (entry) { return totalWeight <= entry.maxGrams; });
    return match || sorted[sorted.length - 1];
  }

  function getServiceFeeLines(lines, serviceKey, service) {
    var serviceLines = (lines || []).filter(function (line) {
      if (!line) { return false; }
      var props = line.properties || {};
      if (props._pkg_fee_service === serviceKey) { return true; }
      if (serviceKey === 'refrigerated' && line.isFeeRefrigerated) { return true; }
      if (serviceKey === 'gift' && line.isFeeGift) { return true; }
      return false;
    });

    if (serviceLines.length) { return serviceLines; }

    var bracketVariantIds = (service && service.brackets ? service.brackets : [])
      .map(function (entry) { return Number(entry && entry.variantId); })
      .filter(function (id) { return Number.isFinite(id) && id > 0; });

    if (!bracketVariantIds.length) { return []; }

    return (lines || []).filter(function (line) {
      return bracketVariantIds.indexOf(Number(line && line.variantId)) !== -1;
    });
  }

  function removeFeeLines(feeLines) {
    var sorted = (feeLines || [])
      .filter(function (line) {
        return !!(line && ((line.key && String(line.key).length > 0) || Number(line.line) > 0));
      })
      .sort(function (a, b) { return Number(b.line) - Number(a.line); });

    var chain = Promise.resolve();
    sorted.forEach(function (line) {
      chain = chain.then(function () {
        if (line.key) {
          return requestCartChange({ id: line.key, quantity: 0 });
        }
        return requestCartChange({ line: Number(line.line), quantity: 0 });
      });
    });
    return chain;
  }

  function shouldCountLine(line, modeKey, optInKey) {
    if (!line || !line[modeKey]) { return false; }
    if (line[modeKey] === 'mandatory') { return true; }
    if (line[modeKey] === 'optional') { return !!line[optInKey]; }
    return false;
  }

  function calculateWeight(lines, serviceKey) {
    var modeKey = serviceKey === 'refrigerated' ? 'refrMode' : 'giftMode';
    var optInKey = serviceKey === 'refrigerated' ? 'refrOptIn' : 'giftOptIn';
    return lines.reduce(function (acc, line) {
      if (line.isFeeRefrigerated || line.isFeeGift) { return acc; }
      if (!shouldCountLine(line, modeKey, optInKey)) { return acc; }
      var weight = Number(line.pkgWeightGrams || 0);
      var qty = Number(line.quantity || 0);
      return acc + Math.max(weight, 0) * Math.max(qty, 0);
    }, 0);
  }

  function cartChange(payload) {
    return fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
  }

  function cartAdd(payload) {
    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
  }

  function parseResponseBody(response) {
    if (!response || typeof response.text !== 'function') { return Promise.resolve(null); }
    return response.text().then(function (textBody) {
      if (!textBody) { return null; }
      try {
        return JSON.parse(textBody);
      } catch (e) {
        return null;
      }
    });
  }

  function requestCartChange(payload) {
    return cartChange(payload).then(function (response) {
      return parseResponseBody(response).then(function (bodyJson) {
        if (!response || !response.ok) {
          var error = new Error('cart/change failed (' + (response ? response.status : 'no-status') + ')');
          error.status = response ? response.status : null;
          error.payload = payload;
          error.bodyJson = bodyJson;
          throw error;
        }
        return bodyJson;
      });
    });
  }

  function requestCartAdd(payload) {
    return cartAdd(payload).then(function (response) {
      return parseResponseBody(response).then(function (bodyJson) {
        if (!response || !response.ok) {
          var error = new Error('cart/add failed (' + (response ? response.status : 'no-status') + ')');
          error.status = response ? response.status : null;
          error.payload = payload;
          error.bodyJson = bodyJson;
          throw error;
        }
        return bodyJson;
      });
    });
  }

  function refreshCartUI() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true, detail: { scrollToTop: false }
    }));
  }

  // Stato desiderato di un servizio rispetto al carrello reso in pagina. Unica fonte per entrambi
  // i consumatori (il sync e la guardia al checkout), cosi non possono divergere.
  function computeServicePlan(serviceKey, feeData) {
    var service = feeData.services && feeData.services[serviceKey];
    if (!service || !service.enabled || !service.feeProductId) { return null; }
    var lines = feeData.lines || [];
    var targetBracket = chooseBracket(service.brackets || [], calculateWeight(lines, serviceKey));
    var feeLines = getServiceFeeLines(lines, serviceKey, service);
    var isSynced = targetBracket
      ? (feeLines.length === 1
        && Number(feeLines[0].variantId) === Number(targetBracket.variantId)
        && Number(feeLines[0].quantity) === 1)
      : feeLines.length === 0;

    return { targetBracket: targetBracket, feeLines: feeLines, isSynced: isSynced };
  }

  // Vero quando il carrello mostrato non corrisponde alla fee attesa: fee assente, fascia sbagliata,
  // quantita diversa da 1, o riga fee orfana dopo la rimozione del prodotto che la giustificava.
  function hasUnsyncedFee(feeData) {
    return ['refrigerated', 'gift'].some(function (serviceKey) {
      var plan = computeServicePlan(serviceKey, feeData);
      return !!plan && !plan.isSynced;
    });
  }

  function syncService(serviceKey, feeData) {
    var plan = computeServicePlan(serviceKey, feeData);
    if (!plan || plan.isSynced) { return Promise.resolve(false); }

    // removeFeeLines su lista vuota si risolve subito: il caso "aggiungi e basta" passa di qui senza ramo dedicato.
    return removeFeeLines(plan.feeLines)
      .then(function () {
        if (!plan.targetBracket) { return null; }
        return requestCartAdd({
          items: [{ id: plan.targetBracket.variantId, quantity: 1, properties: { _pkg_fee_service: serviceKey } }]
        });
      })
      .then(function () { return true; });
  }

  function syncPackagingFees() {
    if (isRunning) { return pendingSyncPromise; }
    var feeData = parseFeeData();
    if (!feeData || !feeData.lines) { return Promise.resolve(false); }
    if (applyCheckoutGuard(feeData)) { return Promise.resolve(false); }
    isRunning = true;
    syncFailed = false;
    // Un servizio per volta: se il refrigerato modifica il carrello, il JSON in pagina e ormai stale.
    // Il re-render che segue riemette cart:rerendered e questa stessa funzione riparte sul gift.
    pendingSyncPromise = syncService('refrigerated', feeData)
      .then(function (refrigeratedChanged) {
        if (refrigeratedChanged) { return [true, false]; }
        return syncService('gift', feeData).then(function (giftChanged) {
          return [false, giftChanged];
        });
      })
      .then(function (results) { if (results.some(Boolean)) { refreshCartUI(); } })
      .catch(function (error) {
        // Senza questo catch un /cart/add.js in errore restava una unhandled rejection: il cliente
        // arrivava al checkout senza fee e senza che nessuno se ne accorgesse (BUG-009, ordini 06-16/08).
        syncFailed = true;
        if (window.console && console.warn) {
          console.warn('[packaging-fee] sincronizzazione fee fallita', error && error.status, error && error.bodyJson, error);
        }
      })
      .finally(function () {
        isRunning = false;
        pendingSyncPromise = null;
      });

    return pendingSyncPromise;
  }

  function updateLinePackagingOptIn(toggle) {
    var line = Number(toggle.getAttribute('data-line'));
    var key = toggle.getAttribute('data-key');
    var service = toggle.getAttribute('data-service');
    var qty = Number(toggle.getAttribute('data-quantity')) || 1;
    var rawProperties = toggle.getAttribute('data-properties');
    var properties = {};
    if ((!line && !key) || !service) { return; }

    function decodeHtmlEntities(value) {
      if (!value || typeof value !== 'string') { return value; }
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    }

    function normalizeProperties(input) {
      var safe = {};

      function normalizePropKey(value) {
        if (value === null || typeof value === 'undefined') { return ''; }
        return decodeHtmlEntities(String(value))
          .replace(/^\s+|\s+$/g, '')
          .replace(/^['"]+|['"]+$/g, '');
      }

      function setSafeProperty(propKey, value) {
        if (propKey === null || typeof propKey === 'undefined') { return; }
        var keyText = normalizePropKey(propKey);
        if (!keyText || /^\d+$/.test(keyText)) { return; }
        if (value === null || typeof value === 'undefined') { return; }
        if (typeof value === 'object') { return; }
        safe[keyText] = String(value);
      }

      if (!input || typeof input !== 'object') { return safe; }

      if (Array.isArray(input)) {
        input.forEach(function (entry) {
          if (Array.isArray(entry) && entry.length >= 2) {
            setSafeProperty(entry[0], entry[1]);
            return;
          }

          if (entry && typeof entry === 'object') {
            if (Object.prototype.hasOwnProperty.call(entry, 'first') || Object.prototype.hasOwnProperty.call(entry, 'last')) {
              setSafeProperty(entry.first, entry.last);
              return;
            }

            Object.keys(entry).forEach(function (entryKey) {
              setSafeProperty(entryKey, entry[entryKey]);
            });
            return;
          }

          if (typeof entry === 'string') {
            try {
              var parsedEntry = JSON.parse(entry);
              if (Array.isArray(parsedEntry) && parsedEntry.length >= 2) {
                setSafeProperty(parsedEntry[0], parsedEntry[1]);
              }
            } catch (e) {}
          }
        });

        return safe;
      }

      Object.keys(input).forEach(function (propKey) {
        setSafeProperty(propKey, input[propKey]);
      });

      return safe;
    }

    var decodedProperties = decodeHtmlEntities(rawProperties || '');
    try {
      properties = decodedProperties ? JSON.parse(decodedProperties) : {};
    } catch (e) {
      try {
        properties = rawProperties ? JSON.parse(rawProperties) : {};
      } catch (e2) {
        properties = {};
      }
    }

    properties = normalizeProperties(properties);

    function unsetServiceProperty(targetProperties, servicePropertyKey) {
      Object.keys(targetProperties).forEach(function (existingKey) {
        var normalizedKey = decodeHtmlEntities(String(existingKey))
          .replace(/^\s+|\s+$/g, '')
          .replace(/^['"]+|['"]+$/g, '');
        if (normalizedKey === servicePropertyKey) {
          delete targetProperties[existingKey];
        }
      });
      // Shopify can keep previous value when key is omitted in some cart/change flows; set blank explicitly.
      targetProperties[servicePropertyKey] = '';
    }

    function setServiceProperty(targetProperties, servicePropertyKey, value) {
      Object.keys(targetProperties).forEach(function (existingKey) {
        var normalizedKey = decodeHtmlEntities(String(existingKey))
          .replace(/^\s+|\s+$/g, '')
          .replace(/^['"]+|['"]+$/g, '');
        if (normalizedKey === servicePropertyKey && existingKey !== servicePropertyKey) {
          delete targetProperties[existingKey];
        }
      });
      targetProperties[servicePropertyKey] = value;
    }

    if (service === 'refrigerated') {
      if (toggle.checked) {
        setServiceProperty(properties, '_pkg_refrigerated', 'yes');
      } else {
        unsetServiceProperty(properties, '_pkg_refrigerated');
      }
    }
    if (service === 'gift') {
      if (toggle.checked) {
        setServiceProperty(properties, '_pkg_gift', 'yes');
      } else {
        unsetServiceProperty(properties, '_pkg_gift');
      }
    }

    function requestToggleChange(payload, strategyLabel) {
      return cartChange(payload).then(function (response) {
        return (response && response.text ? response.text() : Promise.resolve('')).then(function (textBody) {
          var parsedBody = null;
          if (textBody) {
            try { parsedBody = JSON.parse(textBody); } catch (e) { parsedBody = null; }
          }

          if (!response || !response.ok) {
            var httpError = new Error('cart/change failed (' + (response ? response.status : 'no-status') + ')');
            httpError.status = response ? response.status : null;
            httpError.bodyText = textBody || '';
            httpError.bodyJson = parsedBody;
            httpError.payload = payload;
            httpError.strategy = strategyLabel;
            throw httpError;
          }

          return parsedBody;
        });
      });
    }

    var primaryPayload = { quantity: qty, properties: properties };
    var fallbackPayload = null;
    var primaryStrategy = '';
    var fallbackStrategy = '';

    if (line) {
      primaryPayload.line = line;
      primaryStrategy = 'line';
      if (key) {
        fallbackPayload = { quantity: qty, properties: properties, id: key };
        fallbackStrategy = 'id';
      }
    } else if (key) {
      primaryPayload.id = key;
      primaryStrategy = 'id';
    }

    requestToggleChange(primaryPayload, primaryStrategy)
      .catch(function (error) {
        if (!fallbackPayload) { throw error; }
        return requestToggleChange(fallbackPayload, fallbackStrategy);
      })
      .then(function (cart) {
        var items = (cart && Array.isArray(cart.items)) ? cart.items : [];
        var matchedByKey = key ? items.find(function (item) { return item && item.key === key; }) : null;
        var matchedByLine = line && items[line - 1] ? items[line - 1] : null;
        var matchedItem = matchedByLine || matchedByKey || null;

        if (matchedItem) {
          if (matchedItem.key) {
            toggle.setAttribute('data-key', matchedItem.key);
          }
          if (typeof matchedItem.quantity !== 'undefined' && matchedItem.quantity !== null) {
            toggle.setAttribute('data-quantity', String(matchedItem.quantity));
          }
          if (matchedItem.properties && typeof matchedItem.properties === 'object') {
            try {
              toggle.setAttribute('data-properties', JSON.stringify(matchedItem.properties));
            } catch (e) {}
          }
        }

        refreshCartUI();
      })
      .catch(function () {
        refreshCartUI();
      });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') { return; }
    var toggle = target.closest('[data-pkg-toggle]');
    if (!toggle) { return; }
    updateLinePackagingOptIn(toggle);
  });

  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function' || typeof target.querySelector !== 'function') { return; }
    if (!target.closest('form')) { return; }
    if (!target.querySelector('button[name="checkout"], [data-action="checkout"]')) { return; }

    var feeData = parseFeeData();
    if (!feeData || !feeData.lines) { return; }
    if (applyCheckoutGuard(feeData)) {
      event.preventDefault();
      return;
    }

    var syncInFlight = isRunning && pendingSyncPromise;
    if (!syncInFlight && !hasUnsyncedFee(feeData)) {
      pendingNoticeText = null;
      return; // carrello coerente con la fee attesa: si prosegue
    }

    if (checkoutRetryDone && !syncInFlight) {
      // Riallineamento gia tentato senza successo: non si blocca l'acquisto per una fee.
      if (window.console && console.warn) {
        console.warn('[packaging-fee] checkout con fee non allineata dopo un tentativo di sync');
      }
      return;
    }

    // Non si risottomette il form da soli: se qui il carrello cambia, il cliente deve vedere il nuovo
    // totale prima di pagarlo. Si mostra l'avviso e si lascia a lui il secondo clic.
    event.preventDefault();
    checkoutRetryDone = true;
    pendingNoticeText = feeAddedNoticeText;
    renderPackagingAlert(pendingNoticeText);

    (syncInFlight ? pendingSyncPromise : syncPackagingFees()).then(function () {
      if (syncFailed) {
        pendingNoticeText = feeFailedNoticeText;
        renderPackagingAlert(pendingNoticeText);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', syncPackagingFees);
  // Unico trigger post-modifica. Copre anche l'add-to-cart: theme.js risponde a product:added
  // rigenerando il mini-cart via fetch, ed e quel fetch a portare il JSON aggiornato in pagina.
  // Un tempo qui c'era anche un setTimeout(syncPackagingFees, 250) su product:added: partiva prima
  // che il fetch fosse tornato, leggeva il carrello pre-aggiunta e concludeva "nessuna fee da aggiungere".
  // Su pagina prodotto era l'unico trigger vivo, perche cart:rerendered non arrivava (BUG-009).
  document.documentElement.addEventListener('cart:rerendered', function () {
    syncPackagingFees();
  });
})();
